<template>
  <div class="navbar-custom-menu nt-bell-wrap">
    <ul class="nav navbar-nav">
      <li class="dropdown notifications-menu" :class="{ open }">
        <a href="#" class="nt-bell" :title="statusTitle" @click.prevent="toggle">
          <i class="fa fa-bell-o"></i>
          <span v-if="center.unread" class="label nt-bell-count">{{ center.unread > 99 ? '99+' : center.unread }}</span>
        </a>
        <ul v-if="open" class="dropdown-menu nt-bell-menu">
          <li class="header nt-bell-head">
            <span>Notifications</span>
            <a v-if="center.unread" href="#" class="nt-bell-readall" @click.prevent="readAll">Mark all read</a>
          </li>
          <li>
            <ul class="menu nt-bell-list">
              <li v-if="center.loading && !center.items.length" class="nt-bell-empty">Loading…</li>
              <li v-else-if="!center.items.length" class="nt-bell-empty">No notifications yet.</li>
              <li v-for="n in recent" :key="n.id" class="nt-bell-item" :class="{ 'nt-unread': !n.is_read }" @click="openItem(n)">
                <i class="fa nt-bell-icon" :class="[icon(n), `nt-sev-${n.severity}`]"></i>
                <div class="nt-bell-text">
                  <strong>{{ n.title }}</strong>
                  <span v-if="n.body" class="nt-bell-body">{{ n.body }}</span>
                  <span class="nt-bell-time">{{ ago(n.created_at) }}</span>
                </div>
              </li>
            </ul>
          </li>
          <li class="footer"><router-link to="/notifications" @click.native="open = false">View all notifications</router-link></li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { notificationCenter, loadNotifications, markNotificationRead, markAllNotificationsRead, SEVERITY_ICONS, timeAgo } from '../../../utils/notifications'

// Bell in the top bar: unread count and the latest notifications. Mounted once in index.html.
export default {
  name: 'notification-bell',
  data () {
    return { center: notificationCenter.$data, open: false }
  },
  computed: {
    recent () {
      return this.center.items.slice(0, 8)
    },
    statusTitle () {
      return this.center.status === 'connected' ? 'Notifications (live)' : 'Notifications'
    }
  },
  mounted () {
    document.addEventListener('click', this.closeOutside)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeOutside)
  },
  methods: {
    toggle () {
      this.open = !this.open
      if (this.open) loadNotifications()
    },
    closeOutside (event) {
      if (this.open && !this.$el.contains(event.target)) this.open = false
    },
    readAll () {
      markAllNotificationsRead()
    },
    openItem (n) {
      markNotificationRead(n)
      this.open = false
      if (n.link) this.$router.push(n.link)
    },
    icon (n) {
      return SEVERITY_ICONS[n.severity] || SEVERITY_ICONS.info
    },
    ago (value) {
      return timeAgo(value)
    }
  }
}
</script>

<style scoped>
.nt-bell-wrap { float: right; }
.nt-bell { position: relative; }
.nt-bell-count { position: absolute; top: 9px; right: 4px; font-size: 9px; padding: 2px 4px; line-height: 1; background: #d92d20; }
.nt-bell-menu { display: block; width: 360px; max-width: calc(100vw - 16px); right: 0; left: auto; text-align: left; }
.nt-bell-head { display: flex; justify-content: space-between; align-items: center; }
.nt-bell-readall { font-size: 12px; color: #0e7c72; }
.nt-bell-list { max-height: 360px; overflow-y: auto; list-style: none; padding: 0; margin: 0; }
.nt-bell-item { display: flex; gap: 10px; padding: 10px 12px; border-bottom: 1px solid #f2f4f7; cursor: pointer; white-space: normal; }
.nt-bell-item:hover { background: #f9fafb; }
.nt-unread { background: #f0fdfa; }
.nt-bell-icon { margin-top: 2px; font-size: 15px; }
.nt-bell-text { display: flex; flex-direction: column; gap: 2px; font-size: 12.5px; color: #344054; min-width: 0; }
.nt-bell-text strong { color: #101828; font-weight: 600; }
.nt-bell-body { color: #475467; display: -webkit-box !important; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; max-height: 3em; }
.nt-bell-time { font-size: 11px; color: #98a2b3; }
.nt-bell-empty { padding: 14px; font-size: 12.5px; color: #667085; white-space: normal; }
.nt-sev-critical { color: #d92d20; }
.nt-sev-warning { color: #f79009; }
.nt-sev-success { color: #12b76a; }
.nt-sev-info { color: #0e9488; }
</style>



// WEBPACK FOOTER //
// NotificationBell.vue?5f14be2a